const en = {
  login: 'Login',
  account: 'Account',
  connect: 'Connect Wallet',
  send: 'Send',
  sent: 'Sent',
  tokenSymbol: 'Assets Select',
  nostrAssets: 'Nostr Assets Batch Transfer Tool',
  sending: 'Sending',
  currentAddress: 'Current address',
  receiveAddresses: 'Receipt Addresses',
  upgradeAndOpenSwitch: 'Please upgrade your TokenPocket, turn on the nostr switch and retry. <a href="https://help.tokenpocket.pro/en/wallet-operation/protocol/nostr#how-to-enable-nostr-in-tokenpocket" target="_blank">Guide</a>',
  upgradeAndOpenSwitchPC: 'Please upgrade your TokenPocket, turn on the nostr switch and retry. <a href="https://help.tokenpocket.pro/en/wallet-operation/protocol/nostr#browser-extension-use-guide" target="_blank">Guide</a>',
  amountPlaceHolder: '1000',
  addressInvalid: 'receive addresses format is invalid',
  addressPlaceHolder: 'Please enter nostr addresses starting with npub, one address per line',
  sendingAmount: 'Sending amount per address',
  downloadTP: 'Please download TokenPocket to use: <a href="https://tokenpocket.pro/?from=insc" target="_blank"> TokenPocket Wallet</a>'
};

export default en;